/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { IncidentInvestigationControllerSendMessageMutationResponse, IncidentInvestigationControllerSendMessagePathParams } from "../../models/incidentAgentController/IncidentInvestigationControllerSendMessage";

function getIncidentInvestigationControllerSendMessageUrl(id: IncidentInvestigationControllerSendMessagePathParams["id"]) {
  const res = { method: 'POST', url: `/api/v1/incident-agent/investigations/${id}/messages` as const }  
  return res
}

/**
 * {@link /api/v1/incident-agent/investigations/:id/messages}
 */
export async function incidentInvestigationControllerSendMessage(id: IncidentInvestigationControllerSendMessagePathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<IncidentInvestigationControllerSendMessageMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getIncidentInvestigationControllerSendMessageUrl(id).url.toString(), ... requestConfig })  
  return res.data
}